/* Llantired: tarjetas de producto, ventanita UTQG y barra de filtros */
(function () {
  if (window.__llTarjetaLista) return;
  window.__llTarjetaLista = true;

  var SECCION_DATOS = 'buscador-medidas-datos';

  /* ===================== CANTIDAD (+ / -) ===================== */
  function limitar(input, valor) {
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 15;
    if (isNaN(valor)) valor = min;
    return Math.min(max, Math.max(min, valor));
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('.ll-tarjeta__btn-cant');
    if (!boton) return;
    var input = boton.parentElement.querySelector('input[name="quantity"]');
    if (!input || input.disabled) return;
    var cambio = parseInt(boton.dataset.cambio, 10) || 0;
    input.value = limitar(input, parseInt(input.value, 10) + cambio);
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.ll-tarjeta input[name="quantity"]')) return;
    input.value = limitar(input, parseInt(input.value, 10));
  });

  /* ===================== VENTANITA UTQG ===================== */
  function abrirUtqg(valor) {
    var ventana = document.getElementById('ll-utqg');
    if (!ventana) return;

    var esta = ventana.querySelector('[data-ll-utqg-esta]');
    var texto = ventana.querySelector('[data-ll-utqg-valor]');
    var marcador = ventana.querySelector('[data-ll-marcador]');
    var limpio = (valor || '').trim().toUpperCase();
    var partes = limpio.match(/(\d{2,4})\s*(AA|A|B|C)\s*(A|B|C)/);

    // Reiniciar
    marcador.hidden = true;
    ventana.querySelectorAll('.ll-escala').forEach(function (esc) { esc.classList.remove('ll-escala--con-valor'); });
    ventana.querySelectorAll('.ll-escala__pasos span').forEach(function (s) { s.classList.remove('es-actual'); });

    if (partes) {
      esta.hidden = false;
      texto.textContent = partes[1] + ' ' + partes[2] + ' ' + partes[3];

      var desgaste = parseInt(partes[1], 10);
      var porcentaje = Math.min(100, Math.max(0, (desgaste - 100) / 600 * 100));
      marcador.style.left = porcentaje + '%';
      marcador.hidden = false;

      marcarPaso(ventana, 'traccion', partes[2]);
      marcarPaso(ventana, 'temperatura', partes[3]);
    } else {
      esta.hidden = !limpio;
      texto.textContent = limpio === 'N/A' || !limpio ? 'Sin calificación UTQG (N/A)' : limpio;
    }

    if (typeof ventana.showModal === 'function') ventana.showModal();
    else ventana.setAttribute('open', '');
    document.documentElement.classList.add('ll-sin-scroll');
    var cuerpo = ventana.querySelector('.ll-utqg__cuerpo');
    if (cuerpo) cuerpo.scrollTop = 0;
  }

  function marcarPaso(ventana, escala, valor) {
    var contenedor = ventana.querySelector('[data-ll-escala="' + escala + '"]');
    if (!contenedor) return;
    var paso = contenedor.querySelector('[data-valor="' + valor + '"]');
    if (paso) {
      paso.classList.add('es-actual');
      contenedor.classList.add('ll-escala--con-valor');
    }
  }

  function cerrarUtqg(ventana) {
    if (typeof ventana.close === 'function') ventana.close();
    else ventana.removeAttribute('open');
    document.documentElement.classList.remove('ll-sin-scroll');
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-ll-utqg]');
    if (boton) {
      abrirUtqg(boton.getAttribute('data-ll-utqg'));
      return;
    }
    var ventana = e.target.closest('#ll-utqg');
    if (!ventana) return;
    if (e.target.closest('[data-ll-cerrar]') || e.target === ventana) cerrarUtqg(ventana);
  });

  document.addEventListener('close', function (e) {
    if (e.target && e.target.id === 'll-utqg') {
      document.documentElement.classList.remove('ll-sin-scroll');
    }
  }, true);

  /* ===================== BARRA DE FILTROS ===================== */
  function iniciarFiltros(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';

    var base = raiz.dataset.base || '/collections/all';
    var extra = new URLSearchParams(raiz.dataset.extra || '');
    var abrir = raiz.querySelector('[data-ll-filtros-abrir]');
    var panel = raiz.querySelector('.ll-filtros__panel');
    var aviso = raiz.querySelector('[data-ll-filtros-aviso]');
    var selects = Array.prototype.slice.call(raiz.querySelectorAll('select[data-param]'));
    var orden = raiz.querySelector('[data-ll-orden]');
    var cargado = false;
    var turno = 0;

    function mostrarAviso(texto) {
      aviso.textContent = texto;
      aviso.hidden = !texto;
    }

    function construirUrl(seleccion, conSeccion) {
      var url = new URL(base, window.location.origin);
      extra.forEach(function (valor, clave) { url.searchParams.append(clave, valor); });
      seleccion.forEach(function (s) { url.searchParams.append(s.param, s.valor); });
      if (!conSeccion && orden && orden.value) url.searchParams.set('sort_by', orden.value);
      if (conSeccion) url.searchParams.set('section_id', SECCION_DATOS);
      return url;
    }

    function seleccionHasta(indice) {
      return selects.slice(0, indice)
        .filter(function (s) { return s.value; })
        .map(function (s) { return { param: s.dataset.param, valor: s.value }; });
    }

    function obtenerDatos(seleccion) {
      return fetch(construirUrl(seleccion, true).toString())
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nodo = doc.getElementById('buscador-medidas-datos');
          if (!nodo) throw new Error('Sin datos');
          return JSON.parse(nodo.textContent);
        });
    }

    function llenar(select, valores, preferido) {
      var etiquetas = {};
      try { etiquetas = JSON.parse(select.dataset.etiquetas || '{}'); } catch (e) {}
      select.innerHTML = '';
      select.add(new Option(select.dataset.nombre, ''));
      valores
        .filter(function (v) { return v.c > 0 || v.v === preferido; })
        .sort(function (a, b) { return String(a.l).localeCompare(String(b.l), 'es', { numeric: true }); })
        .forEach(function (v) {
          var texto = etiquetas[String(v.v).toUpperCase()] || v.l;
          select.add(new Option(texto, v.v));
        });
      if (preferido && Array.prototype.some.call(select.options, function (o) { return o.value === preferido; })) {
        select.value = preferido;
      }
      select.disabled = select.options.length <= 1;
    }

    // Recarga en cadena los campos desde "inicio" hasta el final
    function recargarDesde(inicio, usarActual) {
      var miTurno = ++turno;
      selects.slice(inicio).forEach(function (s) {
        s.disabled = true;
        s.innerHTML = '';
        s.add(new Option('Cargando…', ''));
      });

      var i = inicio;
      function siguiente() {
        if (miTurno !== turno || i >= selects.length) return Promise.resolve();
        var select = selects[i];
        return obtenerDatos(seleccionHasta(i)).then(function (datos) {
          if (miTurno !== turno) return;
          if (!(select.dataset.param in datos) && select.dataset.opcional) {
            // Filtro opcional que no está activo en Search & Discovery: se oculta sin avisar
            var campo = select.closest('.ll-filtros__campo');
            if (campo) campo.hidden = true;
            select.innerHTML = '';
            select.add(new Option(select.dataset.nombre, ''));
            select.disabled = true;
          } else if (!(select.dataset.param in datos)) {
            select.innerHTML = '';
            select.add(new Option('No disponible', ''));
            select.disabled = true;
            mostrarAviso('Algún filtro no está activo en Search & Discovery; revisa que Ancho, Alto, Rin y Marca estén agregados.');
          } else {
            llenar(select, datos[select.dataset.param], usarActual ? select.dataset.actual : '');
          }
          i++;
          return siguiente();
        });
      }

      return siguiente().catch(function () {
        if (miTurno !== turno) return;
        mostrarAviso('No se pudieron cargar los filtros. Intenta recargar la página.');
        selects.slice(i).forEach(function (s) {
          s.innerHTML = '';
          s.add(new Option(s.dataset.nombre, ''));
          s.disabled = true;
        });
      });
    }

    abrir.addEventListener('click', function () {
      var abierto = abrir.getAttribute('aria-expanded') === 'true';
      abrir.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      panel.hidden = abierto;
      if (!abierto && !cargado) {
        cargado = true;
        mostrarAviso('');
        recargarDesde(0, true);
      }
    });

    selects.forEach(function (select, i) {
      select.addEventListener('change', function () {
        mostrarAviso('');
        if (i < selects.length - 1) recargarDesde(i + 1, false);
      });
    });

    raiz.querySelector('[data-ll-filtros-aplicar]').addEventListener('click', function () {
      var url = construirUrl(seleccionHasta(selects.length), false);
      window.location.href = url.pathname + url.search;
    });

    raiz.querySelector('[data-ll-filtros-limpiar]').addEventListener('click', function () {
      var url = construirUrl([], false);
      window.location.href = url.pathname + url.search;
    });
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-ll-filtros]').forEach(iniciarFiltros);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }
  document.addEventListener('shopify:section:load', iniciarTodo);
})();
